export const isNonEmpty = (self: string): boolean => self.length > 0;
